export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getLifestyleList: function getLifestyleList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/subject/get",
        method: "get",
        params: data
      });
    },
    getLifestyleDraftList: function getLifestyleDraftList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/subject/getDraftList",
        method: "get",
        params: data
      });
    },
    getLifestyleInfo: function getLifestyleInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/lifestyle/".concat(data.id),
        method: "get",
        params: data
      });
    },
    getLifestyleTagListPython: function getLifestyleTagListPython() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/lifestyle/tag/list",
        method: "get",
        params: data
      });
    },
    updateLifestyle: function updateLifestyle() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/lifestyle/".concat(data.id),
        method: "post",
        data: data
      });
    },
    auditLifestyle: function auditLifestyle() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/subject/audit",
        method: "post",
        data: data
      });
    },
    onlineLifestyle: function onlineLifestyle() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/subject/online",
        method: "post",
        data: data
      });
    },
    recommendLifestyle: function recommendLifestyle() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/lifestyle/recommend",
        method: "post",
        data: data
      });
    },
    deleteLifestyle: function deleteLifestyle() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/lifestyle/delete",
        method: "post",
        data: data
      });
    },
    operateLifestyle: function operateLifestyle() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/subject/operate",
        method: "post",
        data: data
      });
    },
    deleteLifestyleComment: function deleteLifestyleComment() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/subject/deleteComment",
        method: "post",
        data: data
      });
    },
    getLifestyleCommentList: function getLifestyleCommentList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/subject/getCommentList",
        method: "get",
        params: data
      });
    },
    getLifestyleRecommendPool1: function getLifestyleRecommendPool1() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/lifestyle/getRecommendPool1",
        method: "get",
        params: data
      });
    },
    getLifestyleRecommendPool2: function getLifestyleRecommendPool2() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/lifestyle/getRecommendPool2",
        method: "get",
        params: data
      });
    }
  };
});